export default {
  permissionCell: {
    textAlign: 'center'
  },
  deleteCell: {
    textAlign: 'right'
  }
}
